// ./components/Input.ts
import { ComponentStyleConfig } from '@chakra-ui/react';

export const Input: ComponentStyleConfig = {
  variants: {
    outline: {
      field: {
        bg: 'white',
      },
    },
  },
};
